module.exports = __webpack_public_path__ + "img/000.bfc2b8a2.jpg";